import { Typography } from "@suraasa/placebo-ui"
import JourneyWithSuraasa from "assets/images/journey-with-suraasa.svg"
import AtheLogo from "assets/logos/athe-logo.svg"
import OfEqualLogo from "assets/logos/ofqual-logo.svg"
import WorldLogo from "assets/logos/world-logo.svg"
import PageContainer from "components/PageContainer"

const FooterBox = (heading: string, subheading: string): JSX.Element => (
  <div className="gap-0.5 rounded-md bg-interactive-50 p-2">
    <Typography variant="title2" className=" text-interactive-900">
      {heading}
    </Typography>
    <Typography variant="smallBody" className="text-onSurface-800">
      {subheading}
    </Typography>
  </div>
)

const Step3Footer = () => {
  return (
    <section className="bg-white">
      <PageContainer>
        <img src={JourneyWithSuraasa} alt="" className="w-full" />
      </PageContainer>
      <div className="h-4"></div>
      <div className="bg-onSurface-800 py-5">
        <PageContainer>
          <div className="grid grid-cols-2 gap-1 sm:grid-cols-4">
            {FooterBox("450,000+", "Teachers")}
            {FooterBox("15,000+", "Schools")}
            {FooterBox("45+", "Countries")}
            {FooterBox("125M+", "Minutes of Learning")}
          </div>
          <div className="h-1"></div>
          <div className="flex flex-row flex-wrap items-center justify-between gap-2  rounded-md bg-onSurface-50 p-2">
            <Typography variant="body" className="text-wrap text-onSurface-800">
              Certifications from recognized Educational bodies and Partnerships
            </Typography>
            <div className="flex gap-5">
              <div className="gap-2">
                <img src={AtheLogo} alt="" />
                <Typography
                  variant="body"
                  className="!text-[10px] text-onSurface-400"
                >
                  AWARDED BY
                </Typography>
              </div>
              <div className="gap-2">
                <img src={OfEqualLogo} alt="" />
                <Typography
                  variant="body"
                  className="!text-[10px] text-onSurface-400"
                >
                  REGULATED BY
                </Typography>
              </div>
              <div className="gap-2">
                <img src={WorldLogo} alt="" />
                <Typography
                  variant="body"
                  className="text-wrap !text-[10px] text-onSurface-400"
                >
                  RECOGNIZED IN MANY NATIONS
                </Typography>
              </div>
            </div>
          </div>
        </PageContainer>
      </div>
    </section>
  )
}

export default Step3Footer
